import { Injectable } from '@angular/core';
import { AktivniJobDto, TableColumnIconDto, VrstaJoba } from '@kodit/core/data-api';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface ProgressItem {
  naziv?: string | undefined;
  iconDto?: TableColumnIconDto | undefined;
  progress?: number | undefined;
  vrstaJoba: VrstaJoba;
}

// export interface IProgressService {
//   //prepareTutorials(currentRoute: string): void;
//   progresses$: BehaviorSubject<ProgressItem[] | []>;
//   progresses: ProgressItem[];
//   getProgresses(curretnRoute: string): Observable<ProgressItem[] | []>;
//   set setProgresses(value: ProgressItem[] | []);
// }

@Injectable({ providedIn: 'root' })
export class ProgressService {
  progresses$ = new BehaviorSubject<ProgressItem[] | []>([]);
  progresses: ProgressItem[] = [];
  progressesMap = new Map<VrstaJoba, BehaviorSubject<number>>();
  private _jobZavrsen$ = new Subject<VrstaJoba>();

  constructor() {}

  getJobZavrsen(vrstaJoba: VrstaJoba): Observable<VrstaJoba> {
    return this._jobZavrsen$
      .asObservable()
      .pipe(filter((x) => x === vrstaJoba));
  }

  getBehaviorSubjectForVrstaJoba(vrstaJoba: VrstaJoba) {
    return this.progressesMap.get(vrstaJoba);
  }

  getProgresses(): Observable<ProgressItem[] | []> {
    return this.progresses$.asObservable();
  }

  addProgresses(vrstaJoba: VrstaJoba) {
    if (this.canBeAdded(vrstaJoba)) {
      var progressItem: ProgressItem = { vrstaJoba: vrstaJoba };
      this.progresses.push(progressItem);
      this.progressesMap.set(vrstaJoba, new BehaviorSubject<number>(0));
      this.progresses$.next(this.progresses);
      // console.log('signal poslat u topbar');
      // console.log(this.progresses);
    }
  }

  deleteProgress(vrstaJoba: VrstaJoba) {
    this.progresses = this.progresses.filter(
      (item) => item.vrstaJoba !== vrstaJoba
    );
    this.progressesMap.delete(vrstaJoba);
    this.progresses$.next(this.progresses);
    this._jobZavrsen$.next(vrstaJoba);
  }

  updateProgress(progresVrsta: VrstaJoba, procenat: number) {
    this.progressesMap.get(progresVrsta).next(procenat);
  }

  getProgressByVrsta(vrstaJoba: VrstaJoba): ProgressItem {
    this.progresses.forEach((progress) => {
      if (progress.vrstaJoba == vrstaJoba) {
        return progress;
      }
    });
    return null;
  }

  // Pomiruje lokalno stanje sa trenutno aktivnim jobovima na serveru - poziva se posle (re)connect-a na
  // SignalR jer je fire-and-forget broadcast mogao da promasi klijenta (izgubljen begin/progress/end event
  // dok je konekcija bila u prekidu). Uklanja "zaglavljene" barove za jobove koji vise nisu aktivni, i
  // dodaje/azurira barove za jobove koji jesu aktivni ali ih klijent (jos) ne prikazuje.
  reconcileWithServer(activeJobs: AktivniJobDto[]) {
    const activeVrste = new Set(activeJobs.map((j) => j.vrstaJoba));

    this.progresses
      .filter((p) => !activeVrste.has(p.vrstaJoba))
      .forEach((p) => this.deleteProgress(p.vrstaJoba));

    activeJobs.forEach((job) => {
      if (this.canBeAdded(job.vrstaJoba)) {
        this.addProgresses(job.vrstaJoba);
      }
      this.updateProgress(job.vrstaJoba, job.progress);
    });
  }

  canBeAdded(vrstaJoba: VrstaJoba): boolean {
    var check = true;
    this.progresses.forEach((progress) => {
      if (progress.vrstaJoba == vrstaJoba) {
        check = false;
      }
    });
    return check;
  }
}
